<template>
  <div>
    <CrudList
      title="Colores"
      storeName="Car_colors"
      :parentStoreName="'Car_brands/'+$route.params.brand_id+'/Car_models'"
      parentUrlKey="model_id"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      labelBack="Atrás"
    >
      <template v-slot:picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.picture">
              <img :src="item.picture" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
